import React, { memo, useEffect, useRef, useState } from "react";

// bootstrap
import { Col, Row, Table } from "react-bootstrap";
import AppFormikInputInline from "utlis/helpers/forms/AppFormikInputInline";
import AppFormikSelectInline from "utlis/helpers/forms/AppFormikSelectInline";
import AppFormikInputFieldRadio from "utlis/helpers/forms/AppFormikInputFieldRadio";

function FormSaleOrders__CustomerInfo(props) {
  const { formik, selectedCustomer, customerGroups,
    foundCustomers, filter, setFoundCustomers, setSelectedCustomer_,
    getCustomerAddresses_, resetAddress
    //  setAddresses, setBAddress, setSAddress 
  } = props;
  const [value, setValue] = useState("")
  const ref = useRef()

  useEffect(() => {
    const checkIfClickedOutside = e => {
      if (foundCustomers && ref.current && !ref.current.contains(e.target)) {
        setFoundCustomers(false)
      }
    }
    document.addEventListener("mousedown", checkIfClickedOutside)
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside)
    }
  }, [props])

  return (
    <React.Fragment >
      {/* form field */}
      <Row >
        <Col xs={12} md={9} lg={12}>
          <div className={"sale-order-label"}>Sale Order For</div>
          <div
            className={`st-form st-form-with-label-left d-flex flex-wrap align-items-center ${formik.touched.active && formik.errors.active
              ? "has-msg msg-error"
              : ""
              }`}
          >
            <div className="media-body st-form-input-container align-left sale-order-for-input">
              <label>
                <input
                  name="u"
                  type="radio"
                  className="custom-radio"
                  value="0"
                  checked={!selectedCustomer.isNew}
                  onChange={(e) => {
                    setSelectedCustomer_({ ...selectedCustomer, isNew: false })
                    formik.resetForm()
                    // setAddresses(arr => [])
                    // setSAddress({})
                    // setBAddress({})
                  }}
                />
                {"   "}
                {` Existing Customer `}
              </label>
              <label className="ms-3">
                <input
                  name="u"
                  type="radio"
                  value="1"
                  className="custom-radio"
                  checked={selectedCustomer.isNew}
                  onChange={(e) => {
                    setSelectedCustomer_({ ...selectedCustomer, isNew: true })
                    resetAddress()
                    // setTimeout(() => {
                    //   formik.resetForm()
                    // }, 200);
                    // setAddresses(arr => [])
                    // setSAddress({})
                    // setBAddress({})
                  }}
                />
                {` New Customer `}
              </label>
              {
                /* form message */
                formik.touched.active && formik.errors.active && (
                  <div className="st-form-msg position-absolute">
                    <p className="st-fs-12">{formik.errors.active}</p>
                  </div>
                )
              }
            </div>
          </div>
        </Col>
      </Row>
      {!selectedCustomer.isNew ? (
        <Row className={'sale-order-for'} id="customer-info">
          <Col xs={12} md={9} lg={9} className="st-form d-flex align-items-center">
            <label className=" st-label-with-left me-2" >Search</label>
            <input type="text" className="form-control" placeholder="Search by Customer Name or Email Address"
              onChange={(e) => {
                setValue(e.target.value)
                filter(e)
              }}
              value={value || ""}
            />
          </Col>
          {(foundCustomers && (foundCustomers.length > 0)) ?
            <div className="app-card-content bg-white border st-border-light st-default-rounded-block 
              customer-list st-listing-table " ref={ref}>
              <Table >
                <thead>
                </thead>
                <tbody className="customer-search-list" >
                  {foundCustomers.map((customer) => (
                    <tr
                      key={customer.user_id}
                      onClick={(e => {
                        customer.isNew = false
                        setSelectedCustomer_(customer)
                        setFoundCustomers(false)
                        getCustomerAddresses_(customer.user_id)
                        setValue("")
                      }
                      )}
                      style={{ width: "100%" }}
                    >
                      <td className="customer-icon" >
                        <div className="icon_">
                          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 16 16"><g transform="translate(838 -946.115)"><circle cx="-830" cy="950.126" r="4" fill="#fff" /><path fill="#fff" d="m -823.99683,959.12321 c 3e-5,0.99379 1e-5,1.98759 1e-5,2.98138 l -12.00635,0 c 0,-0.99379 -1e-5,-1.98759 10e-6,-2.98138" /><path fill="#fff" d="m -823.99682,959.59824 0,-2.19013 c 0,-1.26381 -1.11629,-2.28195 -2.50192,-2.28195 l -7.00251,0 c -1.38564,0 -2.50193,1.01814 -2.50193,2.28195 l 0,2.19013" /></g></svg>
                        </div>
                      </td>
                      <td className="customer-data">
                        <div className="text-capitalize">
                          {customer.first_name}{" "}{customer.middle_name}{" "}{customer.last_name}
                        </div>
                        <div>{customer.email}</div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div> :
            null
          }
          <Col xs={12} md={9} lg={12} className="">
            <div className="d-flex flex-wrap align-items-center ">
              <div className="st-text-color st-fw-600 st-fs-15">Selected Customer: </div>
              <div className="media-body st-form-input-container text-left ms-2">
                <span className="text-capitalize">{selectedCustomer.user_id ?
                  <div className="st-fs-15 st-fw-600 st-text-primary">{selectedCustomer.first_name} {selectedCustomer.middle_name} {selectedCustomer.last_name}</div>
                  : "no customer selected"}</span>
              </div>
            </div>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col xs={12} md={9} lg={4} className="px-0">
            <AppFormikInputInline
              formik={formik}
              stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"}
              labelName={"First Name"}
              isRequired={true}
              placeholder={"First Name"}
              formikFieldName={"first_name"}
            />
          </Col>

          <Col xs={12} md={9} lg={4} className="px-0">
            <AppFormikInputInline
              formik={formik}
              stFormClass={
                "st-form-with-label-left d-flex flex-wrap align-items-center"
              }
              labelName={"Middle Name"}
              isRequired={false}
              placeholder={"Middle Name"}
              formikFieldName={"middle_name"}
            />
          </Col>
          <Col xs={12} md={9} lg={4} className="px-0">
            <AppFormikInputInline
              formik={formik}
              stFormClass={
                "st-form-with-label-left d-flex flex-wrap align-items-center"
              }
              labelName={"Last Name"}
              isRequired={true}
              placeholder={"Last Name"}
              formikFieldName={"last_name"}
            />
          </Col>

          <Col xs={12} md={9} lg={4} className="px-0">
            <AppFormikInputInline
              formik={formik}
              stFormClass={
                "st-form-with-label-left d-flex flex-wrap align-items-center"
              }
              labelName={"Company Name"}
              placeholder={"Company Name"}
              formikFieldName={"company_name"}
              isRequired={false}
            />
          </Col>

          <Col xs={12} md={9} lg={4} className="px-0">
            <AppFormikInputInline
              formik={formik}
              stFormClass={
                "st-form-with-label-left d-flex flex-wrap align-items-center"
              }
              labelName={"Email Address"}
              isRequired={true}
              placeholder={"Email Address"}
              formikFieldName={"email"}
            />
          </Col>
          <Col xs={12} md={9} lg={4} className="px-0">
            <AppFormikInputInline
              formik={formik}
              stFormClass={
                `st-form-with-label-left d-flex flex-wrap align-items-center ${formik.errors?.password?.length > 23 ? "customer-password" : ""}`
              }
              labelName={"Password"}
              isRequired={true}
              placeholder={"Password"}
              formikFieldName={"password"}
              inputType={"password"}
            />
          </Col>
          <Col xs={12} md={9} lg={4} className="px-0">
            <AppFormikSelectInline
              formik={formik}
              stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center"}
              labelName={"Customer Group"}
              formikFieldName={"customer_group_id"}
            >
              <option value="" disabled>Select Customer Group</option>
              {(customerGroups && customerGroups.length) && customerGroups.map(item => (
                <option
                  key={item.group_id.toString()}
                  value={item.group_id.toString()}
                >{item.group_name}</option>
              ))
              }
            </AppFormikSelectInline>

          </Col>

          <Col xs={12} md={9} lg={4} className="px-0">
            <AppFormikInputFieldRadio
              formik={formik}
              stFormClass={
                "st-form st-form-with-label-left d-flex flex-wrap align-items-center"
              }
              labelName={"Exclusive Offers"}
              formikFieldName={"exclusiveOffers"}
              labelNameRight={"I would like to receive updates and offers"}
            />
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
}

export default memo(FormSaleOrders__CustomerInfo);
